import React from "react"
import { Text, Link } from "theme-ui"
import { format } from "date-fns"
import { Link as GatsbyLink } from "gatsby"

const Categories = ({ categories }) => {
  const cleaned = categories.split(",").map((category) => category.trim())

  return cleaned.map((category, i) => (
    <>
      <Link
        as={GatsbyLink}
        to={`/categories/${category.toLowerCase()}`}
        key={category}
      >
        {category}
      </Link>
      {i < cleaned.length - 1 ? ", " : ""}
    </>
  ))
}

const ArticleMetaData = ({ frontmatter }) => {
  if (frontmatter.published) {
    return (
      <Text mb={[1, 1, 2]}>
        Published on {format(new Date(frontmatter.published), "MMMM do, yyyy")}{" "}
        in <Categories categories={frontmatter.categories || "Uncategorized"} />
      </Text>
    )
  } else {
    return null
  }
}

export default ArticleMetaData
